import { LOCALES } from '../locales';
export default {
    [LOCALES.ENGLISH]: {
        'hello': 'Hello',
        "Continue": "Continue"
    }
}